export enum FrequencyDates {
  ONCE = 'Однократно',
  WEEKLY = 'Еженедельно',
  DATES = 'По датам',
  NONE = 'NONE',
}

export enum FrequencyDatesBack {
  ONCE = 'once',
  WEEKLY = 'weekly',
  DATES = 'dates',
  NONE = 'none',
}

export enum WeekDays {
  SUNDAY = 'Вс',
  MONDAY = 'Пн',
  TUESDAY = 'Вт',
  WEDNESDAY = 'Ср',
  THURSDAY = 'Чт',
  FRIDAY = 'Пт',
  SUTURDAY = 'Сб',
  EVERY_DAY_CHECKBOX = 'Ежедневно',
}

export enum WeekDaysBack {
  SUNDAY = 'Su',
  MONDAY = 'Mo',
  TUESDAY = 'Tu',
  WEDNESDAY = 'We',
  THURSDAY = 'Th',
  FRIDAY = 'Fr',
  SUTURDAY = 'Sa',
}

export enum NewsTabs {
  PUBLICATED = 'publicated',
  UNPUBLICATED = 'unpublicated',
  ARCHIVE = 'archive',
}

export enum NewsTabsRus {
  PUBLICATED = 'Опубликована',
  UNPUBLICATED = 'Не опубликовано',
  ARCHIVE = 'В архиве',
}

export const NewsTabsToRus = {
  [NewsTabs.PUBLICATED]: NewsTabsRus.PUBLICATED,
  [NewsTabs.UNPUBLICATED]: NewsTabsRus.UNPUBLICATED,
  [NewsTabs.ARCHIVE]: NewsTabsRus.ARCHIVE,
};

export const FrequencyDatesToBack = {
  [FrequencyDates.ONCE]: FrequencyDatesBack.ONCE,
  [FrequencyDates.WEEKLY]: FrequencyDatesBack.WEEKLY,
  [FrequencyDates.DATES]: FrequencyDatesBack.DATES,
  [FrequencyDates.NONE]: FrequencyDatesBack.NONE,
};

export const FrequencyDatesToFront = {
  [FrequencyDatesBack.ONCE]: FrequencyDates.ONCE,
  [FrequencyDatesBack.WEEKLY]: FrequencyDates.WEEKLY,
  [FrequencyDatesBack.DATES]: FrequencyDates.DATES,
  [FrequencyDatesBack.NONE]: FrequencyDates.NONE,
};

export const WeekDaysToBack = {
  [WeekDays.SUNDAY]: WeekDaysBack.SUNDAY,
  [WeekDays.MONDAY]: WeekDaysBack.MONDAY,
  [WeekDays.TUESDAY]: WeekDaysBack.TUESDAY,
  [WeekDays.WEDNESDAY]: WeekDaysBack.WEDNESDAY,
  [WeekDays.THURSDAY]: WeekDaysBack.THURSDAY,
  [WeekDays.FRIDAY]: WeekDaysBack.FRIDAY,
  [WeekDays.SUTURDAY]: WeekDaysBack.SUTURDAY,
};

export const WeekDaysToFront = {
  Su: WeekDays.SUNDAY,
  Mo: WeekDays.MONDAY,
  Tu: WeekDays.TUESDAY,
  We: WeekDays.WEDNESDAY,
  Th: WeekDays.THURSDAY,
  Fr: WeekDays.FRIDAY,
  Sa: WeekDays.SUTURDAY,
};

export enum SearchKeysNews {
  SEARCH_NAME = 'searchName',
  SEARCH_TITLE = 'searchTitle',
  SEARCH_ID = 'byId',
  PERSONNEL_NUMBER = 'personnelNumber',
  POSITION_NAME = 'positionName',
  DIVISION_NAME = 'divisionName',
  SEARCH = 'search',
}
